import { render } from "./BasicUsage.vue?vue&type=template&id=4ab2c8b6"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"
script.render = render

export default script